module.exports = __webpack_public_path__ + "img/safetyImg2.84495318.png";